import toastr from '@/lib/notifications'
import $ from 'jquery'
import store from '../state/store'

store.on('placement_managers:index', function() {
  $.ajax({
    url: '/api/sales/placement_managers',
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    success: (data) => {
      const items = data.items
      store.get().ui.request_placement.set({placement_managers: items})

      // Requests default to Unassigned (coordinator or SDR backlog), so the
      // current user is no longer pre-selected.
      // const request_placement = store.get().ui.request_placement
      // if (!request_placement.placement_manager_id) {
      //   const current_user = store.get().user
      //   const mine = current_user && items.find((m) => String(m.user_id) === String(current_user.id))
      //
      //   if (mine) {
      //     store.get().ui.request_placement.set({placement_manager_id: mine.id})
      //   }
      // }
    },
    error: (data) => {
      return toastr.error(
        (data && data.responseJSON && data.responseJSON.custom_error_message) || 'Could not load placement managers'
      )
    }
  })
})
